module.exports = __webpack_public_path__ + "img/parter-work5.d39f6953.png";